<template>
    <div @click="state.isOpen = true" class="cursor-pointer">
        <slot> </slot>
    </div>
    <ModalCustom
        :is-open="state.isOpen"
        @close="state.isOpen = false"
        title="Report Post"
    >
        <form action="/new-forum/report-post" method="POST">
            <input type="hidden" name="_token" :value="$root.csrfToken" />
            <input type="hidden" name="thread_id" :value="props.threadId" />
            <input type="hidden" name="post_id" :value="props.postId" />
            <app-input
                class="min-h-[200px]"
                name="message"
                type="textarea"
                placeholder="Describe your report"
            ></app-input>
            <div class="flex mt-4 justify-between">
                <button
                    type="button"
                    class="
                        flex
                        py-2
                        px-6
                        border
                        font-bold
                        border-accent
                        rounded-full
                        text-accent
                        items-center
                    "
                    @click="state.isOpen = false"
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    class="
                        rounded-full
                        bg-gradient-to-br
                        py-2
                        px-6
                        from-red-400
                        to-red-500
                        text-white
                        p-1
                    "
                >
                    Report Post
                </button>
            </div>
        </form>
    </ModalCustom>
</template>

<script setup>
import { defineProps, reactive } from "vue";

const props = defineProps(["threadId", "postId"]);

const state = reactive({
    isOpen: false,
});
</script>
